import { ReactElement } from 'react';
import { EditOrderI } from './editPersonal';
import EditOrderDesktopPersonal from './editOrderDesktopPersonal';

const EditOrderDesktop = ({
  handleClose,
  handleSavePersonalInformation,
  personalRegisteredFields,
  errors,
  months,
  currentValueMonth,
  handleChangeMonth,
  docTypes,
  currentValueDocType,
  handleChangeDocType,
  isOrderStatusDone,
}: EditOrderI): ReactElement => {
  return (
    <EditOrderDesktopPersonal
      handleClose={handleClose}
      handleSavePersonalInformation={handleSavePersonalInformation}
      personalRegisteredFields={personalRegisteredFields}
      errors={errors}
      months={months}
      currentValueMonth={currentValueMonth}
      handleChangeMonth={handleChangeMonth}
      docTypes={docTypes}
      currentValueDocType={currentValueDocType}
      handleChangeDocType={handleChangeDocType}
      isOrderStatusDone={isOrderStatusDone}
    />
  );
};

export default EditOrderDesktop;
